import { Link } from "@tanstack/react-router";
import { Linkedin, Mail } from "lucide-react";
import { services } from "@/data/services";
import { NO_RELIANCE } from "@/data/terms";
import { openConsentSettings } from "@/lib/consent";
import { DECISION_SPRINT_LIVE } from "@/lib/flags";

import { Logo } from "./Logo";

export function SiteFooter() {
  return (
    <footer className="bg-midnight-deep py-16 text-frost/80">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-1">
            <Logo tone="light" className="h-8 sm:h-9" />


            <p className="mt-5 max-w-xs text-sm leading-relaxed text-frost/70">
               Senior, hands-on fractional COO leadership for founder-led businesses generating
              $3M to $30M, ready to scale with structure, clarity and follow-through.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.linkedin.com/in/adamayoub/"
                target="_blank"
                rel="noreferrer"
                className="grid h-11 w-11 place-items-center rounded-full border border-white/10 transition hover:border-steel hover:text-frost"
                aria-label="Ajility on LinkedIn (opens in a new tab)"
              >
                <Linkedin className="h-4 w-4" aria-hidden="true" />
              </a>
              <a
                href="mailto:adam@ajility.com.au"
                className="grid h-11 w-11 place-items-center rounded-full border border-white/10 transition hover:border-steel hover:text-frost"
                aria-label="Email adam@ajility.com.au"
              >
                <Mail className="h-4 w-4" aria-hidden="true" />
              </a>
            </div>

          </div>

          <nav aria-labelledby="footer-services-heading">
            <span id="footer-services-heading" className="block text-sm font-semibold uppercase tracking-wider text-frost">
              Services
            </span>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/services" className="transition hover:text-frost">
                  All fractional COO services
                </Link>
              </li>
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={s.to} className="transition hover:text-frost">
                    {s.name}
                  </Link>
                </li>
              ))}
              {DECISION_SPRINT_LIVE ? (
                <li>
                  <Link to="/decision-sprint" className="transition hover:text-frost">
                    Decision Sprint
                  </Link>
                </li>
              ) : null}
            </ul>
          </nav>

          <nav aria-labelledby="footer-expertise-heading">
            <span id="footer-expertise-heading" className="block text-sm font-semibold uppercase tracking-wider text-frost">
              Expertise
            </span>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/specialisations" className="transition hover:text-frost">
                  All expertise
                </Link>
              </li>
              <li>
                <Link to="/specialisations/pricing-and-revenue-management" className="transition hover:text-frost">
                  Pricing and revenue management
                </Link>
              </li>
              <li>
                <Link to="/specialisations/planning-budgeting-and-forecasting" className="transition hover:text-frost">
                  Planning, budgeting and forecasting
                </Link>
              </li>
              <li>
                <Link to="/specialisations/roles-targets-and-incentives" className="transition hover:text-frost">
                  Roles, targets and incentives
                </Link>
              </li>
              <li>
                <Link to="/specialisations/project-and-commercial-control" className="transition hover:text-frost">
                  Project and commercial control
                </Link>
              </li>
              <li>
                <Link to="/specialisations/procurement-and-supplier-costs" className="transition hover:text-frost">
                  Procurement and supplier costs
                </Link>
              </li>
              <li>
                <Link to="/specialisations/systems-selection-and-implementation" className="transition hover:text-frost">
                  Systems selection and implementation
                </Link>
              </li>
            </ul>
          </nav>



          <nav aria-labelledby="footer-company-heading">
            <span id="footer-company-heading" className="block text-sm font-semibold uppercase tracking-wider text-frost">
              Company
            </span>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/about" className="transition hover:text-frost">
                  About
                </Link>
              </li>
              <li>
                <Link to="/advisers" className="transition hover:text-frost">
                  For Advisers &amp; Partners
                </Link>
              </li>
              <li>
                <Link to="/packages" className="transition hover:text-frost">
                  Packages
                </Link>
              </li>
              <li>
                <Link to="/tools" className="transition hover:text-frost">
                  Tools
                </Link>
              </li>
              <li>
                <Link to="/scan" className="transition hover:text-frost">
                  Operating Scan
                </Link>
              </li>
              <li>
                <Link to="/insights" className="transition hover:text-frost">
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/giving" className="transition hover:text-frost">
                  Causes we support
                </Link>
              </li>
              <li>
                <Link to="/contact" className="transition hover:text-frost">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-labelledby="footer-reach-heading">
            <span id="footer-reach-heading" className="block text-sm font-semibold uppercase tracking-wider text-frost">
              Reach
            </span>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/fractional-coo-australia" className="transition hover:text-frost">
                  Fractional COO Australia
                </Link>
              </li>
              <li>
                <Link to="/fractional-general-manager" className="transition hover:text-frost">
                  Fractional General Manager
                </Link>
              </li>
              <li>
                <Link to="/fractional-coo-sydney" className="transition hover:text-frost">
                  Fractional COO Sydney
                </Link>
              </li>
              <li>
                <Link to="/fractional-coo-melbourne" className="transition hover:text-frost">
                  Fractional COO Melbourne
                </Link>
              </li>
              <li>
                <Link to="/fractional-coo-perth" className="transition hover:text-frost">
                  Fractional COO Perth
                </Link>
              </li>
              <li>
                <Link to="/fractional-coo-newcastle" className="transition hover:text-frost">
                  Fractional COO Newcastle
                </Link>
              </li>
              <li>
                <Link to="/fractional-coo-central-coast" className="transition hover:text-frost">
                  Fractional COO Central Coast
                </Link>
              </li>
            </ul>
          </nav>

        </div>


        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-sm text-frost/80 md:flex-row">
          <p>
            © {new Date().getFullYear()} AJILITY PTY LTD · ABN 39 649 782 427. All rights reserved.{" "}
            <Link to="/privacy" className="hover:text-frost">Privacy</Link>
            {", "}
            <Link to="/terms" className="hover:text-frost">Terms</Link>
            {", "}
            <a href="/sitemap.xml" className="hover:text-frost">Sitemap</a>
            {", "}
            <a href="/llms.txt" className="hover:text-frost">llms.txt</a>
            {", "}
            <button
              type="button"
              onClick={openConsentSettings}
              className="underline-offset-2 hover:text-frost hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-frost"
            >
              Cookie settings
            </button>
          </p>
          <p className="italic">
            "Strategy without execution is hallucination."
          </p>
        </div>
        <p className="mt-4 text-center text-xs leading-relaxed text-frost/70">
          {NO_RELIANCE}
        </p>
      </div>

    </footer>
  );
}
